export default [
  {
    // 个人中心
    path: '/check',
    name: 'check',
    component: () => import('@/pages/checkActive/index.vue'),
    // redirect: '/pullNew/home',
    // children: [
    //   {
    //     path: 'home',
    //     meta: {
    //       title: '启航教育',
    //     },
    //     component: () => import('@/pages/pullNew/home/home.vue'), // 拉新首页
    //   },
    //   {
    //     path: 'help',
    //     meta: {
    //       title: '启航教育',
    //     },
    //     component: () => import('@/pages/pullNew/help/help.vue'), // 拉新助力页
    //   },
    //   {
    //     path: 'helper',
    //     meta: {
    //       title: '启航教育',
    //     },
    //     component: () => import('@/pages/pullNew/help/newHelp.vue'), // 拉新助力页
    //   },
    //   {
    //     path: 'helpList',
    //     meta: {
    //       title: '启航教育',
    //     },
    //     component: () => import('@/pages/pullNew/helpList/helpList.vue'), // 拉新助力页
    //   },
    //   {
    //     path: 'over',
    //     meta: {
    //       title: '启航教育',
    //     },
    //     component: () => import('@/pages/pullNew/over/over.vue'), // 拉新结束
    //   },
    //   {
    //     path: 'prize',
    //     meta: {
    //       title: '启航教育',
    //     },
    //     component: () => import('@/pages/pullNew/prize/prize.vue'), // 拉新奖品列表
    //   },
    //   {
    //     path: 'list',
    //     meta: {
    //       title: '启航教育',
    //     },
    //     component: () => import('@/pages/pullNew/pullNewList.vue'), // 拉新奖品列表
    //   },
    // ],
  },
];
